<template>
  <div class="wapper">
    <el-container style="100%">
      <DocumentType @getDocumentTypeId="getDocumentTypeId"></DocumentType>
      <el-main style="background: #fff; margin-left: 10px">
        <div class="table-wrap">
          <div class="handle-box3">
            <el-form
                :inline="true"
                ref="form"
                :model="searchForm"
                class="demo-form-inline handle-search"
            >
              <div class="uers-left">
                <el-form-item label="搜索：">
                  <el-input
                      v-model="searchForm.name"
                      placeholder="姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.code"
                      placeholder="码值"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.idNumber"
                      placeholder="编号"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-select v-model="searchForm.projectDoor" placeholder="选择门禁点">
                    <el-option
                        v-for="(type, index) in ProjectDoor"
                        :label="type.name"
                        :key="index"
                        :value="type.name"
                    >
                      <div @click="getChangeDoorType(type)">
                        {{ type.name }}
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                      v-model="searchForm.meetingId"
                      placeholder="选择项目会议"
                  >
                    <el-option :value="0" label="选择项目会议"></el-option>
                    <el-option
                        v-for="(type, index) in Meeting"
                        :label="type.name"
                        :key="index"
                        :value="type.meetingId"
                    >
                      <div>{{ type.name }}</div>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-date-picker
                      v-model="searchForm.startDate"
                      type="datetime"
                      placeholder="开始日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="">
                  <el-date-picker
                      v-model="searchForm.endDate"
                      type="datetime"
                      placeholder="开始日期"
                  ></el-date-picker>
                </el-form-item>
                <el-button type="primary" @click="searchSubmit">搜索</el-button>
                <el-button type="primary" @click="exportExcel">导出</el-button>
              </div>
            </el-form>
<!--            <el-form :inline="true" class="demo-form-inline handle-search">-->
<!--              <div class="usrs-right">-->
<!--                <el-form-item label="标签设置：">-->
<!--                  <el-select v-model="label" placeholder="选择标签">-->
<!--                    <el-option-->
<!--                        v-for="(type, i) in labels"-->
<!--                        :key="i"-->
<!--                        :label="type.name"-->
<!--                        :value="type.name"-->
<!--                    >-->
<!--                      {{ type.name }}-->
<!--                    </el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->
<!--                <el-form-item>-->
<!--                  <el-button-->
<!--                      type="primary"-->
<!--                      icon="el-icon-edit"-->
<!--                      @click="saveLabel"-->
<!--                  >保存-->
<!--                  </el-button-->
<!--                  >-->
<!--                  <el-button-->
<!--                      type="primary"-->
<!--                      icon="el-icon-delete"-->
<!--                      @click="delLabel"-->
<!--                  >删除-->
<!--                  </el-button-->
<!--                  >-->
<!--                </el-form-item>-->
<!--              </div>-->
<!--            </el-form>-->
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                height="100%"
                border
                class="tabbox"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                @selection-change="handleSelectionChange"
            >
              <el-table-column
                  type="selection"
                  width="55"
                  align="center"
              ></el-table-column>
              <el-table-column prop="name" label="名称/会议" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.meeting }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="code" label="编号/码值" align="center"
                               width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.code }}</span><br/>
                  <span>{{ scope.row.idNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="idNumber"
                  label="身份证"
                  align="center"
                  width="150"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.idCard }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="door" label="门禁点" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.door }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="time" label="年龄" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.type }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="time" label="性别" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.time }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="healthCode" label="省" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.healthCode }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="temperature" label="市" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.temperature }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="nucleicAcid" label="区" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.nucleicAcid }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="avatar" label="头像" align="center">
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.avatar"
                        :preview-src-list="[scope.row.avatar]"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="createDate"
                  label="创建时间"
                  align="center"
                  width="150"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="删除" width="180" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditPapersManage from "../../../components/ticketing/certificate/EditPapersManage";
import DocumentType from "../../../components/ticketing/certificate/docuType/DocumentType";
import DeleteDialog from "../../../components/public/DeleteConfim";

export default {
  data() {
    return {
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      //表格高度适配
      tabheight: "",
      searchForm: {
        meetingId: 0,
        name: "",
        code: "",
        idNumber: "",
        documentTypeId: 0,
        projectDoor: "",
        endDate: new Date(
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ),
        startDate: new Date(
            new Date(new Date().toLocaleDateString()).getTime() -
            (new Date(new Date().toLocaleDateString()).getTime() -
                new Date(new Date().getFullYear().toString()))
        ),
      },
      label: "",
      delVisible: false,
      document_Id: "",
      dataList: [],
      multipleSelection: [],
      projectId: localStorage.getItem("project_Id"),
      ProjectDoor: [],
      Meeting: [],
    };
  },
  mounted() {
    // this.tabheight=(this.$refs.getheight.offsetHeight-165)
  },
  created() {
    this.getData();
    this.getProjectDoor();
    this.getLabel();
    this.getMeeting();
  },
  methods: {
    getMeeting() {
      this.$axios.get("/Meeting/Project/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.Meeting = [...res.data.data];
        }
      });
    },
    downloadPost(url) {
      return new Promise((resolve, reject) => {
        axios({
          url: url,// 请求地址
          method: 'post',
          responseType: 'blob'// 表明返回服务器返回的数据类型
        }).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err);
        });
      });
    },
    delLabel() {
      if (this.label == "") {
        this.$message.error("请选择标签");
        return;
      }
      if (confirm("是否将当前查询所有数据删除标签【" + this.label + "】？")) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        var search = {
          name: this.searchForm.name,
          code: this.searchForm.code,
          idNumber: this.searchForm.idNumber,
          projectId: this.projectId,
          pageIndex: this.currentPage - 1,
          pageSize: this.total,
          startDate: this.searchForm.startDate,
          endDate: this.searchForm.endDate,
          documentTypeId: this.searchForm.documentTypeId,
          projectDoor: this.searchForm.projectDoor,
          labelSet: "delete",
          meetingId: this.searchForm.meetingId
        };
        this.$axios
            .post(`/AccessRecord/Label/` + this.label, search)
            .then((res) => {
              loading.close();
              if (!res.data.hasError) {
                this.$message.success("删除完成");
              } else {
                this.$message.error("保存失败");
              }
            })
            .catch((a) => {
              loading.close();
              this.$message.error("保存失败");
            });
      }
    },
    saveLabel() {
      if (this.label == "") {
        this.$message.error("请选择标签");
        return;
      }
      if (confirm("是否将当前查询所有数据保存为标签【" + this.label + "】？")) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        var search = {
          name: this.searchForm.name,
          code: this.searchForm.code,
          idNumber: this.searchForm.idNumber,
          projectId: this.projectId,
          pageIndex: this.currentPage - 1,
          pageSize: this.total,
          startDate: this.searchForm.startDate,
          endDate: this.searchForm.endDate,
          documentTypeId: this.searchForm.documentTypeId,
          projectDoor: this.searchForm.projectDoor,
          labelSet: "add",
        };
        this.$axios
            .post(`/AccessRecord/Label/` + this.label, search)
            .then((res) => {
              loading.close();
              if (!res.data.hasError) {
                this.$message.success("保存完成");
              } else {
                this.$message.error("保存失败");
              }
            })
            .catch((a) => {
              loading.close();
              this.$message.error("保存失败");
            });
      }
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.searchSubmit();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchSubmit();
    },
    getLabel() {
      this.$axios.get("/Label/Project/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.labels = [...res.data.data];
        }
      });
    },
    img(url) {
      window.open(url);
    },
    exportExcel() {
      var search = {
        name: this.searchForm.name,
        code: this.searchForm.code,
        idNumber: this.searchForm.idNumber,
        projectId: this.projectId,
        pageIndex: this.currentPage - 1,
        pageSize: this.total,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        documentTypeId: this.searchForm.documentTypeId,
        projectDoor: this.searchForm.projectDoor,
        meetingId: this.searchForm.meetingId
      };
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
          .post("/AccessRecord/Document/Export", search)
          .then((res) => {
            loading.close();
            if (res.data.data) {
              window.open(res.data.data, '_self');
              // this.$download(res.data.data, '导出通行记录.xlsx');
            } else {
              this.$message.error("导出失败");
            }
          })
          .catch((a) => {
            loading.close();
            this.$message.error("导出失败");
          });
    },
    searchSubmit() {
      var search = {
        name: this.searchForm.name,
        code: this.searchForm.code,
        idNumber: this.searchForm.idNumber,
        projectId: this.projectId,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        documentTypeId: this.searchForm.documentTypeId,
        projectDoor: this.searchForm.projectDoor,
        meetingId: this.searchForm.meetingId
      };
      this.$axios.post("/AccessRecord/Document/Search", search).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    getDocumentTypeId(val) {
      this.searchForm.documentTypeId = val;
      this.getData();
    },
    // 获取数据
    getData() {
      this.currentPage = 1;
      this.searchSubmit();
    },
    handleDelete(index, row) {
      this.document_Id = row.accessRecordId;
      this.delVisible = true;
    },
    deleteData() {
      this.$axios.delete(`/AccessRecord/${this.document_Id}`).then((res) => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("删除成功！");
          this.delVisible = false;
          this.getData();
        }
      });
    },
    getChangeDoorType(type) {
      this.searchForm.projectDoorId = type.projectDoorId;
    },
    getProjectDoor() {
      console.log(this.projectId);
      this.$axios.get("/ProjectDoor/Project/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.ProjectDoor = [...res.data.data];
        }
      });
    },
    handleCloseVisible() {
      this.document_Id = "";
      this.delVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  components: {
    EditPapersManage,
    DocumentType,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.uers-left {
  float: left;
}

.uers-right {
  float: right;
}

.table-wrap {
  height: 100%;
  margin-left: 10px;
}

.el-main {
  border-radius: 5px;
  position: relative;
}

.tabbox {
  height: calc(100% - 100px);
}
</style>